module.exports = __webpack_public_path__ + "media/images/sp/stores/funabashi/access/chiba-funabashi-point2-2-76c866f301601845c02ceca2b2d0287d.webp";